import React from 'react';
import AdminLayout from './AdminLayout';
import BankAccountsManager from './BankAccountsManager';

export default function AdminPaymentOptions() {
  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1>Payment Options</h1>
          <p>Manage the bank accounts and logos customers can choose at checkout</p>
        </div>
      </div>
      <BankAccountsManager />
    </AdminLayout>
  );
}